import { creatorbase } from '@round/api';
import { useCampaigns } from '@round/creatorbase-helpers/api-hooks';
import { getProjectCampaignsListParams } from './projectCampaignsListParams';
import useProjectDetails from '@/Modules/Plans/Project/ProjectDetails/useProjectDetails';

export function useProjectCampaigns(platform: creatorbase.Platform) {
    const { project } = useProjectDetails();
    const pageSize = project?.campaign_count;
    const projectId = project?.id;
    const enabled = typeof projectId === 'number' && typeof pageSize === 'number';
    const params = getProjectCampaignsListParams(projectId ?? 0, platform, pageSize || 1);
    const query = useCampaigns(params, { enabled });

    return {
        ...query,
        isInitialized: query.isSuccess || query.isError,
    };
}
